import { client } from './axios';

const product = (params) => client.get(`/products`, { params });
const productDetail = (id) => client.get(`/product/${id}`);

export const productService = {
    product,
    productDetail,
};
